import React from "react";
import { RCCButton, RCCIcon, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import HeaderDashboard from "src/components/DashboardComponents/DefaultDashboardComponents/HeaderDashboard";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { GroupersOKR } from "src/pages/StrategicPlanning/Okr/interface";
import { v4 } from "uuid";
import { ICardConfigs, MAX_HEIGHT_LISTS_DASHBOARD } from "../../../interface";
import { IDashboardOKRsData } from "../interface";
import Li from "./li";
import * as Styles from "./styles";

const DashboardListsSectorOKRs: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	
	const {data, loading} = useEffectFetchData<IDashboardOKRsData[]> (
		"DashboardOKRs/ListSector"
	);

	const dataCard = data && data.length > 0 ? data : [{
		total: 0,
		withoutValue: 0,
		notOnTarget: 0,
		onTarget: 0,
		delayed: 0,
		group: 0,
		groupDescription: ""
	}] as IDashboardOKRsData[];
	
	return(
		<>
			<DefaultContainer>
				<HeaderDashboard 
					description={card?.daa002Descricao}
					title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Resumo de OKRs por Setor")}
					hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
					isLoading={loading}
				>
					<Link to={`/okr/panel/?group=${GroupersOKR.SECTOR}`} >
						<RCCTooltip
							text={translate("Painel de OKR")}
							color="grey"
						>
							<RCCButton
								color="transparent"
							>
								<AppIcons 
									name="strategicPlanning"
									size={14}
								/>
							</RCCButton>
						</RCCTooltip>
					</Link>
				</HeaderDashboard>
				<DefaultBody maxHeight={MAX_HEIGHT_LISTS_DASHBOARD}>
					<Styles.LiTitles>
						<div />
						<div><RCCTooltip text={translate("Total")} color="purple" >{translate("Total")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Sem checkin")} color="blue" >{translate("Sem checkin")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Checkin parcial")} color="yellow" >{translate("Checkin parcial")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Atrasado")} color="red" >{translate("Atrasado")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Atingiu a meta")} color="green" >{translate("Atingiu a meta")} </RCCTooltip></div>
					</Styles.LiTitles>

					{dataCard && dataCard.map((item: IDashboardOKRsData) => (
						<React.Fragment key={v4()}>
							<Styles.LiPanelBodyContent>
								<div>
									<Title color="purple" size="sm">
										{item.groupDescription && item.groupDescription !== "" ? item.groupDescription : translate("Sem setor")} 
									</Title>
									<Title color="purple" size="xs">
										<RCCIcon 
											color="var(--purple-light)"
											name="hierarchy"
											style={{ margin: "0 0.5rem"}}
										/>
										{translate("Objetivos")}
									</Title>
								</div>
								<Li data={item} showLink />
							</Styles.LiPanelBodyContent>

							<Styles.LiPanelBodyContent>
								<div>
									<Title color="purple" size="xs">
										<RCCIcon 
											color="var(--purple-light)"
											name="key"
											style={{ margin: "0 0.5rem"}}
										/>
										{translate("Resultados chave")} 
									</Title>
								</div>
								<Li data={item?.keyResults} />
							</Styles.LiPanelBodyContent> 

						</React.Fragment>
					))}
					
				</DefaultBody>
			</DefaultContainer>
		</>
	);
};

export default DashboardListsSectorOKRs;
